import {Feature} from './feature.class';

export class RoleFeature {
    role_id: number;
    feature_id: number;
    user_field: any;
    created_at: any;
    updated_at: any;
    feature: Feature;
}